import React, { useState } from 'react'
 
 
import LeaveTemplateList from './LeaveTemplateList';
import LeaveTemplateForm from './LeaveTemplateForm';

const LeaveTemplate= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <LeaveTemplateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <LeaveTemplateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default LeaveTemplate